import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Signup1 from './Signup1';
import ErrorBoundary from '../../ErrorBoundary';
class Signup extends Component {
  constructor() {
    super();
    this.state = {
      signup1CompletedVal: false
    }
  }

  render() {
    return (
      <ErrorBoundary>
      <div className="row col-md-12 p-0 m-0">
        <link rel="stylesheet" href="./assets/css/styles.css" />
        <link rel="stylesheet" href="assets/css/responsive.css" />
        <link rel="stylesheet" href="assets/css/adminlte.css" />
        <div className="col-md-5">
          <Switch>
            <Route path='/signup' component={Signup1}></Route>
          </Switch>
        </div>
        <div className="col-md-7 pay2-bg" />
      </div>
      </ErrorBoundary>
    );
  }
}

export default Signup;

// export default function Signup() {
//   return (
//     <div className="row col-md-12 p-0 m-0">
//       <link rel="stylesheet" href="./assets/css/styles.css" />
//       <link rel="stylesheet" href="assets/css/responsive.css" />
//       <link rel="stylesheet" href="assets/css/adminlte.css" />
//       <div className="col-md-5">
//         <Switch>
//           <Route path='/signup' component={Signup1}></Route>
//         </Switch>
//       </div>
//       <div className="col-md-7 pay2-bg" />
//     </div>
//   );
// }


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Signup.js